import React from 'react';
// import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';


const PendingOrdersCounter = () => {
    const { positions } = useSelector((state) => (state.account.positions.pending), shallowEqual);
    const { MainColor: { ActiveText } } = useSelector((state) => (state.brand.theme));
    const openPositionsQuantity = Object.keys(positions).length;


    return (
        <div className='quantity-mark' style={{ backgroundColor: ActiveText }}>
            {openPositionsQuantity}
        </div>
    );
};

// PendingOrdersCounter.propTypes = {};

export default PendingOrdersCounter;
